function getTokenWithKey(spaceKey, enteredPassword, handleSuccess) {

    try {

        // send password and username to api and retrieve space and role information
        fetch('https://cybertwin3login-ctdzg7dfbve8fhbp.ukwest-01.azurewebsites.net/getpublickey', {

            headers: {
                "SpaceKey": spaceKey,
                "Password": enteredPassword,
                'Content-type': 'application/json; charset=utf-8'

            },
        }).then(response => {

            if (response.ok) {
                /////console.log("Response OK....");
                response.json().then(
                    json => {
                        /////console.log(json);
                        const obj = json;
                        const myJSON = JSON.stringify(obj);
                        /////console.log(myJSON);
                        const myObj = JSON.parse(myJSON);
                        const id = myObj['projectID'];
                        const spaceKey = myObj['spaceKey'];
                        const spaceId = myObj['spaceId'];
                        /////console.log("the spaceKey is: " + spaceKey);
                        const previewKey = myObj['previewKey'];
                        /////console.log("the previewKey is: " + previewKey);
                        const logoKey = myObj['logoKey'];
                        const pass = enteredPassword.toString();
                        const user = spaceKey.toString();
                        ///console.log("Succesfully authenticated : " + user + " : " + pass);
                        handleSuccess(spaceId, id, spaceKey, logoKey, previewKey);
                    })
            }
            else {
                handleSuccess("", "failed", "", "", "", "", "", "");
            }
        }

        )


    }
    catch (error) {
        handleSuccess("", "failed", "", "", "", "", "", "");
    }

};

export default getTokenWithKey;